import React from 'react';

// AirAcademia Logo Component - Beyaz/Mavi kağıt uçak logosu
const AirAcademiaLogo = ({ size = 'default', showText = true, variant = 'dark', className = '' }) => {
  const sizes = {
    sm: { icon: 36, text: 'text-base' },
    small: { icon: 36, text: 'text-base' },
    default: { icon: 44, text: 'text-xl' },
    large: { icon: 56, text: 'text-2xl' },
    xlarge: { icon: 72, text: 'text-3xl' },
  };

  const { icon: iconSize, text: textSize } = sizes[size] || sizes.default;
  
  // Beyaz veya mavi varyant
  const isWhite = variant === 'white' || variant === 'light';

  return (
    <div className={`flex items-center gap-3 ${className}`}>
      {/* Paper Airplane Icon */}
      <svg
        width={iconSize}
        height={iconSize}
        viewBox="0 0 48 48"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        {isWhite ? (
          <>
            {/* Beyaz versiyon */}
            <path
              d="M8 24L42 8L32 42L24 28L8 24Z"
              fill="white"
              fillOpacity="0.9"
            />
            <path
              d="M8 24L42 8L24 28L8 24Z"
              fill="white"
            />
            <path
              d="M24 28L32 42L42 8"
              stroke="white"
              strokeWidth="1"
              strokeOpacity="0.5"
              fill="none"
            />
          </>
        ) : (
          <>
            {/* Mavi versiyon */}
            <defs>
              <linearGradient id="planeGradient" x1="0%" y1="0%" x2="100%" y2="100%">
                <stop offset="0%" stopColor="#3B82F6" />
                <stop offset="50%" stopColor="#1D4ED8" />
                <stop offset="100%" stopColor="#1E40AF" />
              </linearGradient>
              <linearGradient id="planeGradientLight" x1="0%" y1="0%" x2="100%" y2="100%">
                <stop offset="0%" stopColor="#60A5FA" />
                <stop offset="100%" stopColor="#3B82F6" />
              </linearGradient>
            </defs>
            <path
              d="M8 24L42 8L32 42L24 28L8 24Z"
              fill="url(#planeGradient)"
            />
            <path
              d="M8 24L42 8L24 28L8 24Z"
              fill="url(#planeGradientLight)"
            />
            <path
              d="M24 28L32 42L42 8"
              stroke="#1E3A8A"
              strokeWidth="1"
              strokeOpacity="0.3"
              fill="none"
            />
          </>
        )}
      </svg>
      
      {/* Text: airacademia */}
      {showText && (
        <span className={`font-bold tracking-tight ${textSize}`}>
          {isWhite ? (
            <>
              <span className="text-white">air</span>
              <span className="text-blue-200">academia</span>
            </>
          ) : (
            <>
              <span className="text-blue-500">air</span>
              <span className="text-blue-800">academia</span>
            </>
          )}
        </span>
      )}
    </div>
  );
};

// Simple inline logo for headers (beyaz versiyon default)
export const AirAcademiaLogoSimple = ({ className = '', variant = 'dark' }) => {
  const isWhite = variant === 'white' || variant === 'light';
  
  return (
    <div className={`flex items-center gap-3 ${className}`}>
      <svg
        width="40"
        height="40"
        viewBox="0 0 48 48"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        {isWhite ? (
          <>
            <path d="M8 24L42 8L32 42L24 28L8 24Z" fill="white" fillOpacity="0.9" />
            <path d="M8 24L42 8L24 28L8 24Z" fill="white" />
          </>
        ) : (
          <>
            <defs>
              <linearGradient id="planeGradientSimple" x1="0%" y1="0%" x2="100%" y2="100%">
                <stop offset="0%" stopColor="#3B82F6" />
                <stop offset="100%" stopColor="#1E40AF" />
              </linearGradient>
            </defs>
            <path d="M8 24L42 8L32 42L24 28L8 24Z" fill="url(#planeGradientSimple)" />
            <path d="M8 24L42 8L24 28L8 24Z" fill="#60A5FA" />
          </>
        )}
      </svg>
      <span className="font-bold text-xl">
        {isWhite ? (
          <>
            <span className="text-white">air</span>
            <span className="text-blue-200">academia</span>
          </>
        ) : (
          <>
            <span className="text-blue-500">air</span>
            <span className="text-blue-800">academia</span>
          </>
        )}
      </span>
    </div>
  );
};

// Icon only version
export const AirAcademiaLogoIcon = ({ size = 40, className = '', variant = 'dark' }) => {
  const isWhite = variant === 'white' || variant === 'light';
  
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      {isWhite ? (
        <>
          <path d="M8 24L42 8L32 42L24 28L8 24Z" fill="white" fillOpacity="0.9" />
          <path d="M8 24L42 8L24 28L8 24Z" fill="white" />
        </>
      ) : (
        <>
          <defs>
            <linearGradient id={`planeGradientIcon${size}`} x1="0%" y1="0%" x2="100%" y2="100%">
              <stop offset="0%" stopColor="#3B82F6" />
              <stop offset="100%" stopColor="#1E40AF" />
            </linearGradient>
          </defs>
          <path d="M8 24L42 8L32 42L24 28L8 24Z" fill={`url(#planeGradientIcon${size})`} />
          <path d="M8 24L42 8L24 28L8 24Z" fill="#60A5FA" />
        </>
      )}
    </svg>
  );
};

// Backwards compatibility - export as KariyerLogo too
export const KariyerLogo = AirAcademiaLogo;
export const KariyerLogoSimple = AirAcademiaLogoSimple;
export const KariyerLogoIcon = AirAcademiaLogoIcon;

export default AirAcademiaLogo;
